"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.northwestTerritoriesCities = void 0;
exports.northwestTerritoriesCities = [
    {
        label: "Coleville Lk",
        value: 9029,
    },
    {
        label: "Deline",
        value: 9032,
    },
    {
        label: "Detah",
        value: 9038,
    },
    {
        label: "Enterprise",
        value: 9046,
    },
    {
        label: "Fort Liard",
        value: 9041,
    },
    {
        label: "Fort Rae",
        value: 8020,
    },
    {
        label: "Fort Simpson",
        value: 7249,
    },
    {
        label: "Fort Smith, NT",
        value: 8030,
    },
    {
        label: "Ft Good Hope",
        value: 9030,
    },
    {
        label: "Ft Providenc",
        value: 9044,
    },
    {
        label: "Ft Resolutio",
        value: 9047,
    },
    {
        label: "Ft.Mcpherson",
        value: 9027,
    },
    {
        label: "Hay River, NT",
        value: 8040,
    },
    {
        label: "Holman",
        value: 9024,
    },
    {
        label: "Iklavik",
        value: 9026,
    },
    {
        label: "Inuvik, NT",
        value: 8060,
    },
    {
        label: "Jeanmarie Ri",
        value: 9042,
    },
    {
        label: "Kakisa",
        value: 9045,
    },
    {
        label: "Lutselk'e",
        value: 9039,
    },
    {
        label: "Nahanni Butt",
        value: 9040,
    },
    {
        label: "Norman Wells",
        value: 9031,
    },
    {
        label: "Other",
        value: 8099,
    },
    {
        label: "Paulatuk",
        value: 9048,
    },
    {
        label: "Rae Lakes",
        value: 9035,
    },
    {
        label: "Sachs Harbou",
        value: 9023,
    },
    {
        label: "Snare Lakes",
        value: 9036,
    },
    {
        label: "Trout Lake",
        value: 9043,
    },
    {
        label: "Tsiligetchik",
        value: 9028,
    },
    {
        label: "Tuktoyaktuk",
        value: 9025,
    },
    {
        label: "Tulita",
        value: 9033,
    },
    {
        label: "Wrigley",
        value: 9034,
    },
    {
        label: "Yellowknife, NT",
        value: 8090,
    },
];
